export default __webpack_public_path__ + "static/media/publicICARLogo.8f228962.svg";